import { inEnum } from "@ciaopeople/cp-shatsu/TypeChecking";
import { PlayerEvent, isPlayerEvent } from "@mp-commons/modules/events/PlayerEvent.js";

export enum MegarideEventType {

    MEGARIDE_PLAYLIST_START = "megaride_playlist_start",
    MEGARIDE_PLAYLIST_END = "megaride_playlist_end"

}

export interface MegarideEvent extends PlayerEvent{

    eventType: MegarideEventType
}


export function isMegarideEvent(x: any): x is MegarideEvent {

    return isPlayerEvent(x) && 
        ("eventType" in x && inEnum(x.eventType,MegarideEventType))
}